import React from 'react'
import { Provider } from 'react-redux'
import { BotPOIExtensionDisplay } from './components/BotPOIExtensionDisplay'
import type { MapProps } from './components/Map'
import { MapDisplay } from './components/Map'
import { POILoader } from './components/POILoader'
import { setupStore } from './stores/globalStore'

import './styles/module.scss'
import type { MapLabel, MapSettings } from './models/Map'
import { POIType } from './models/POI'

declare let require: any
require('./theme/variables.scss')
require('./theme/global.scss')

const store = setupStore()
const Map = (props?: MapProps | undefined): JSX.Element => {
  console.log('JE PASSE ICI')
  return (
    <>
      {props && props.activeTenant ? (
        <Provider store={store}>
          <MapDisplay {...props} />
          <POILoader
            tenantName={props.activeTenant}
            retorikName={props.tenantList[props.activeTenant].retorikName}
          />
          <BotPOIExtensionDisplay />
        </Provider>
      ) : (
        <></>
      )}
    </>
  )
}

export { MapIcon } from './styles/icons/map'
export { Map, POIType }
export type { MapSettings, MapLabel }
export type { Tenant } from './models/Tenant'
